<!--
 * @Author: jzh
 * @Date: 2020-11-19 15:36:22
 * @LastEditors: DQL
 * @LastEditTime: 2022-02-09 21:45:40
 * @Description: file content
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-no-modal-bg o-dialog--sm o-dialog--md-80 o-dialog--lg-90 o-dialog--xl-60 page-addAdmini"
    title="新增管理员"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <div
      class="dev-admin-selection"
    >
      <el-form
        ref="fd"
        class="c-form u-mg-b-8"
        :inline="true"
        label-position="right"
        label-suffix="："
        label-width="100px"
      >
        <el-row
          class="c-form__row"
        >
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="管理员级别"
            >
              <span
                class="c-form__read"
              >
                {{ dlParams.adminLevelName }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="所属组织"
            >
              <hm-tree-select
                v-model="currentDeptCode"
                class="c-tree-select-wrap"
                instance-id="cTreeSelect"
                placeholder="请选择组织"
                :append-to-body="true"
                :options="selectTreeOptions"
                :normalizer="normalizer"
                :clearable="false"
                @input="getDeptUsers"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!-- <el-tree
        ref="deptTree"
        class="o-tree-overflow--unset"
        :data="treeData"
        :props="defaultProps"
        highlight-current
        :default-expanded-keys="defaultExpandedKeys"
        :expand-on-click-node="false"
        lazy
        @node-click="handleNodeClick"
      /> -->
      <!-- table的ref的命名根据业务名称修改 -->
      <el-table
        ref="listTable"
        class="o-header-text-center"
        height="330px"
        stripe
        border
        highlight-current-row
        tooltip-effect="dark"
        :data="currentDeptUserList"
        :class="{ 'o-table-empty-center': currentDeptUserList.length <= 0 }"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="40"
          align="center"
        />
        <el-table-column
          prop="userCode"
          label="用户编码"
          min-width="140"
          show-overflow-tooltip
        />
        <el-table-column
          prop="userName"
          label="用户名称"
          min-width="140"
          show-overflow-tooltip
        />
      </el-table>
    </div>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <el-button
        type="primary"
        :disabled="multipleSelectedRow.length<=0"
        @click="handleSave()"
      >
        保存
      </el-button>
      <el-button
        @click="closeDialog()"
      >
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import AddDialog from '@/features/system/adminLevelManage/addDialog.vue';
export default {
  name: 'AddDialog',
  extends: AddDialog
};
</script>
